import {flowRight} from 'lodash';

export type Point = {
  x: number;
  y: number;
};

export const subtract = (a: Point, b: Point): Point => ({
  x: a.x - b.x,
  y: a.y - b.y,
});

export const magnitude = ({x, y}: Point): number => Math.sqrt(x * x + y * y);

export const distance: (arg1: Point, arg2: Point) => number = flowRight(
  magnitude,
  subtract
);
